import { Component, Inject, OnInit, Optional } from '@angular/core';
import { FormControl } from '@angular/forms';
import { Observable, Subject } from 'rxjs';
import { EMRService } from 'app/EMR/EMR.service';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { EyecheckComponent } from 'app/EMR/eyecheck/eyecheck.component';
import { HelpListPopupComponent } from 'app/EMR/Doctor/doctor-other-info/help-list-popup/help-list-popup.component';
import { AuthService } from 'app/auth/auth.service';
import { DynamicHelpListComponent } from 'app/EMR/Doctor/doctor-other-info/dynamic-help-list/dynamic-help-list.component';
import { DashboardService } from 'app/dashboard/dashboard.service';
import { takeUntil } from 'rxjs/operators';

@Component({
  selector: 'app-additional_vision',
  templateUrl: './additional_vision.component.html',
  styleUrls: ['./additional_vision.component.scss']
})
export class Additional_visionComponent implements OnInit {
  myControl = new FormControl();
  destroyvision$: Subject<boolean> = new Subject<boolean>();
  options: string[] = ['One', 'Two', 'Three'];
  filteredOptions: Observable<string[]>;
  private boxDisabled: string = 'Add';
  private selectValue: any;   
  constructor(private emrservice: EMRService, private authService: AuthService, private dashboardService:DashboardService,
    private dialog: MatDialog,private dialogRef: MatDialogRef<Additional_visionComponent>, @Optional() @Inject(MAT_DIALOG_DATA) private data: any) { 
      dialogRef.disableClose = true;
    }

  ngOnInit() {
    this.emrservice.students_opto = {};
    this.emrservice.students_opto_list = [];
    this.emrservice.get_student_opto_lists();
   
  }

  

  getsphvalue(category: string, valuebox: string) {
    this.emrservice.ar_value_box = valuebox;
    this.emrservice.eyechkcategory = category;
    const dialogRef = this.dialog.open(EyecheckComponent, {

      panelClass: 'full-width-dialog',
      minHeight: '200px',
      width: '50%',
      disableClose: true,
      data: {
        //category: category,
        //userid: this.authService.Loggeduser.userid
      }

    });

    dialogRef.afterClosed().pipe(takeUntil(this.destroyvision$)).subscribe(result => {
      //  console.log('The dialog was closed');
      //pid = result;
      // this.surgicalhistory_ds = new MatTableDataSource(this.emrservice.surgicalhistory.slice());

    });
  }
  private _filter(value: string): string[] {
    const filterValue = value.toLowerCase();

    return this.options.filter(option => option.toLowerCase().indexOf(filterValue) === 0);
  }

  prepare_add() {
    this.emrservice.students_opto = {};
  }

  // Axis 
  refhelplistPOpup(type, value) {
    const dialogRef = this.dialog.open(HelpListPopupComponent, {
      panelClass: 'full-width-dialog',
      maxWidth: '33vw',
      disableClose: true,
      width: '33%',
      data: {
        typeid: type
      }
    });

   dialogRef.afterClosed().pipe(takeUntil(this.destroyvision$)).subscribe(result => {
      if (result != 0) {
        this.selectValue = result;
        if (type == 23) {
          this.set_opto_finalglass_student_axis(value)
        }
        // this.set_ar_value(value);

      }
    });
  }

  // helplist pop up 
  refMultiPopup(name, type) {
    const dialogRef = this.dialog.open(DynamicHelpListComponent, {
      panelClass: 'full-width-dialog',
      maxWidth: '33vw',
      disableClose: true,
      width: '33%',
      data: {
        parametertype: name
      }
    });

    dialogRef.afterClosed().pipe(takeUntil(this.destroyvision$)).subscribe(result => {
      if (result != 0) {
        if (type == 1) {
          this.emrservice.students_opto.refractionType = result;
        }
      }
    });
  }

  getUsername(id){
     let username = this.authService.users.filter(item => item.pkUserId == id)[0];
     return username.userName;
  }

  addDisabledbox(value) {
    this.boxDisabled = value;
  }
  set_opto_finalglass_student_axis(row) {
    switch (row) {
      // row 1 final glass 
      case "r1c3_fg_student": {
        this.emrservice.students_opto.udra1 = this.selectValue;
        break;
      }
      case "r1c9_fg_student": {
        this.emrservice.students_opto.udla1 = this.selectValue;
        break;
      }

      // row 2 
      case "r2c3_fg_student": {
        this.emrservice.students_opto.udra2 = this.selectValue;
        break;
      }
      case "r2c9_fg_student": {
        this.emrservice.students_opto.udla2 = this.selectValue;
        break;
      }

      // row 3       
      case "r3c3_fg_student": {
        this.emrservice.students_opto.udra3 = this.selectValue;
        break;
      }
      case "r3c9_fg_student": {
        this.emrservice.students_opto.udla3 = this.selectValue;
        break;
      }
    }
  }
  
  closedialog(){
    this.dialogRef.close(0);
  }
  // Update Glass Prescription Data
  updateGp() {
    let updateItem = this.emrservice.students_opto;
    let objlength = Object.keys(updateItem).length;
    if (objlength != 0) {
      this.emrservice.opto["gprsd"] = updateItem.udrs1 ? updateItem.udrs1 : null;
      this.emrservice.opto["gprsn"] = updateItem.udrs2 ? updateItem.udrs2 : null;
      this.emrservice.opto["gprsI"] = updateItem.udrs3 ? updateItem.udrs3 : null;
      this.emrservice.opto["gprcd"] = updateItem.udrc1 ? updateItem.udrc1 : null;
      this.emrservice.opto["gprcn"] = updateItem.udrc2 ? updateItem.udrc2 : null;
      this.emrservice.opto["gprcI"] = updateItem.udrc3 ? updateItem.udrc3 : null;
      this.emrservice.opto["gprad"] = updateItem.udra1 ? updateItem.udra1 : null;
      this.emrservice.opto["gpran"] = updateItem.udra2 ? updateItem.udra2 : null;
      this.emrservice.opto["gpraI"] = updateItem.udra3 ? updateItem.udra3 : null;
      this.emrservice.opto["gprvd"] = updateItem.udrv1 ? updateItem.udrv1 : null;
      this.emrservice.opto["gprvn"] = updateItem.udrv2 ? updateItem.udrv2 : null;
      this.emrservice.opto["gprvI"] = updateItem.udrv3 ? updateItem.udrv3 : null;
      this.emrservice.opto["gprpd"] = updateItem.udrp1 ? updateItem.udrp1 : null;
      this.emrservice.opto["gprpn"] = updateItem.udrp2 ? updateItem.udrp2 : null;
      this.emrservice.opto["gprpI"] = updateItem.udrp3 ? updateItem.udrp3 : null;
      this.emrservice.opto["gpnvr1"] = updateItem.udnvr1 ? updateItem.udnvr1 : null;
      this.emrservice.opto["gplsd"] = updateItem.udls1 ? updateItem.udls1 : null;
      this.emrservice.opto["gplsn"] = updateItem.udls2 ? updateItem.udls2 : null;
      this.emrservice.opto["gplsI"] = updateItem.udls3 ? updateItem.udls3 : null;
      this.emrservice.opto["gplcd"] = updateItem.udlc1 ? updateItem.udlc1 : null;
      this.emrservice.opto["gplcn"] = updateItem.udlc2 ? updateItem.udlc2 : null;
      this.emrservice.opto["gplcI"] = updateItem.udlc3 ? updateItem.udlc3 : null;
      this.emrservice.opto["gplad"] = updateItem.udla1 ? updateItem.udla1 : null;
      this.emrservice.opto["gplan"] = updateItem.udla2 ? updateItem.udla2 : null;
      this.emrservice.opto["gplaI"] = updateItem.udla3 ? updateItem.udla3 : null;
      this.emrservice.opto["gplvd"] = updateItem.udlv1 ? updateItem.udlv1 : null;
      this.emrservice.opto["gplvn"] = updateItem.udlv2 ? updateItem.udlv2 : null;
      this.emrservice.opto["gplvI"] = updateItem.udlv3 ? updateItem.udlv3 : null;
      this.emrservice.opto["gplps"] = updateItem.udlp1 ? updateItem.udlp1 : null;
      this.emrservice.opto["gplpn"] = updateItem.udlp2 ? updateItem.udlp2 : null;
      this.emrservice.opto["gplpI"] = updateItem.udlp3 ? updateItem.udlp3 : null;
      this.emrservice.opto["gpnvl1"] = updateItem.udnvl1 ? updateItem.udnvl1 : null;
      this.dashboardService.openSnackBar("Updated Glass Prescription Data Successfully", "OK");
    }
  }
  ngOnDestroy():void {
    this.destroyvision$.next(true);
    this.destroyvision$.unsubscribe();
  
  }
}
